import { styled } from "@mui/material";

export const ChainEmitter = styled('div')(({ theme }) => ({
  border: "none",
  background: "none",
  padding: "none",
  height: theme.spacing(3),
  color: theme.palette.primary.main,
  fontFamily: theme.typography.fontFamily,
  fontWeight: 700,
  marginRight: theme.spacing(-2),
  paddingRight: theme.spacing(1.5),
  display: "flex",
  alignItems: "center",
  fontSize: 10
}))

export const ChainPointStyled = styled('button')(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  padding: 0,
  border: "none",
  cursor: "pointer",
  width: 10,
  height: 10,
  borderRadius: 9999,
  position: "absolute",
  right: -10 / 2
}))